import { gql } from '@apollo/client'

export const GET_HOURLY_PRICE = gql`
    query BookingGetHourlyPrice($lot_id: String!, $num_hours: Int!, $pricing_type: BookingPricingModelType!) {
        booking_get_price_hourly(lot_id: $lot_id, num_hours: $num_hours, pricing_type: $pricing_type) {
            offered_prices
        }
    }
`
